export default "__VITE_ASSET__8fed72de__"